<template>
  <div class="row reverse-mobile justify-content-center">
    <AdminMenu />

    <div class="col-12 col-md-9 center-content">
      <CommunityCard class="p-4">
        <h3 class="text-inherit mb-4">Pending Media</h3>

        <PleaseWait v-if="isLoading" bg-colour="#ffffff" class="my-4" />

        <ul v-if="!isLoading && pendingMedia.length" class="list-style-none">
          <li class="my-2" v-for="media in pendingMedia" :key="media.id">
            <div class="request-container d-flex">
              <div class="w-25 m-2">
                <img
                  @click="openImagePreview(media.signed_full_url)"
                  style="width: 100%; cursor: pointer"
                  :src="media.signed_thumb_url"
                  alt="image to review"
                />
              </div>
              <div class="m-2" style="width: calc(75% - 1rem)">
                <div class="titlerow">
                  <div class="title-text">
                    <h5>{{ media.name }}</h5>
                    <div class="title-creator">
                      {{
                        media.contributed_by.first_name +
                        " " +
                        media.contributed_by.last_name
                      }}
                      -
                      {{ getPrettyDate(media.contributed_at) }}
                    </div>
                  </div>
                  <div>
                    <button
                      class="btn btn-outline mx-1 btn-primary"
                      :ref="'approvemedia-' + media.uuid_id"
                      @click="approveMedia(media.uuid_id)"
                    >
                      Approve
                    </button>

                    <div class="dropdown d-inline-block">
                      <button
                        :ref="'rejectmedia-' + media.uuid_id"
                        class="btn btn-outline mx-1 btn-danger dropdown-toggle"
                        type="button"
                        :id="'rejectdropdown-' + media.uuid_id"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Decline
                      </button>
                      <div
                        class="dropdown-menu dropdown-menu-right"
                        :aria-labelledby="'rejectdropdown-' + media.uuid_id"
                      >
                        <span
                          v-for="reason in REJECT_REASONS"
                          class="dropdown-item"
                          @click="rejectMedia(media.uuid_id, reason)"
                        >
                          {{ reason }}
                        </span>
                        <span
                          class="dropdown-item"
                          @click="showOtherReasonPopup(media.uuid_id)"
                        >
                          Other
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bodyrow">
                  {{ media.description }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </CommunityCard>
    </div>
  </div>
</template>

<script>
import AdminMenu from "@/components/AdminMenu";
import CommunityCard from "@/components/CommunityCard";
import PleaseWait from "@/components/PleaseWait";
import mediaService from "@/services/media.service";
import Media from "@/components/Media";

export default {
  name: "AdminPendingMedia",
  components: {
    Media,
    AdminMenu,
    CommunityCard,
    PleaseWait,
  },
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      pendingMedia: [],
      REJECT_REASONS: [
        "Contains identifying information",
        "Inappropriate",
        "Wrong tags",
        "Missing tags",
      ],
    };
  },
  mounted() {
    this.getPendingMedia();
  },
  methods: {
    getPendingMedia() {
      if (this.isLoading) return;
      this.isLoading = true;

      mediaService
        .getAllPending()
        .then((data) => (this.pendingMedia = data))
        .catch((err) => console.log(err))
        .finally(() => (this.isLoading = false));
    },
    approveMedia(mediaUuid) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["approvemedia-" + mediaUuid];
      btn.innerHTML = "...";

      mediaService
        .approveMedia(mediaUuid)
        .then(() => {
          this.$swal
            .fire("Success!", "Media approved", "success")
            .then(this.getPendingMedia);
        })
        .catch((err) => this.$swal.fire("Error", err, "error"))
        .finally(() => {
          this.isSubmitting = false;
          btn.innerHTML = "Approve";
        });
    },
    showOtherReasonPopup(mediaUuid) {
      this.$swal
        .fire({
          title: "Enter a reason for declining",
          input: "text",
          showCancelButton: true,
          confirmButtonText: "Submit",
          inputAttributes: {
            maxlength: 250,
          },
        })
        .then((result) => {
          if (result.value && result.value.trim()) {
            this.rejectMedia(mediaUuid, result.value);
          }
        });
    },
    rejectMedia(mediaUuid, reason) {
      if (this.isSubmitting) return;
      this.isSubmitting = true;

      const btn = this.$refs["rejectmedia-" + mediaUuid];
      btn.innerHTML = "...";

      mediaService
        .rejectMedia(mediaUuid, reason)
        .then(() => {
          this.$swal
            .fire("Success!", "Media declined", "success")
            .then(this.getPendingMedia);
        })
        .catch((err) => this.$swal.fire("Error", err, "error"))
        .finally(() => {
          this.isSubmitting = false;
          btn.innerHTML = "Reject";
        });
    },
    getPrettyDate(dateString) {
      return new Date(dateString).toLocaleString();
    },
    openImagePreview(url) {
      const alert = vm.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
          confirmButtonText: "Close",
        },
        buttonsStyling: false,
        heightAuto: true,
        html: `<div class="full-screen-preview preview-container" >
            <img style="max-height: 100%; width: 90%" 
              alt="preview" src="${url}"/>
          </div>`,
      });
      alert.fire({});
    },
  },
};
</script>

<style scoped>
table {
  font-size: 0.9rem;
  width: 100%;
}

td:first-child {
  width: 20%;
}

tr {
  border-bottom: 1px solid #f1f1f1;
  height: 40px;
}

tr:last-child {
  border-bottom: none;
}

.request-container {
  border: 1px solid #ddd;
  padding: 6px;
  border-radius: 4px;
  margin: 16px auto;
}
.titlerow {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.title-creator {
  font-style: italic;
  font-size: 0.8em;
}
.bodyrow {
  margin: 10px auto 0;
}

.dropdown-item {
  cursor: pointer;
}
</style>
